import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { Helpers } from './utils/helpers';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const helpers = inject(Helpers);
  const router = inject(Router);

  // ✅ Look for child permissions first, then parent
  const requiredPermissions = (route.data?.['permissions'] ?? route.parent?.data?.['permissions'] ?? []) as string[];

  return helpers.hasPermission$(requiredPermissions).pipe(
    map((allowed) => {
      if (!allowed) {
        router.navigate(['/']); // ✅ redirect dashboard
        return false;
      }
      return true;
    })
  );
};
